import { AnyAction } from "redux";
import { ILoadWebsiteAction } from "./actions/loadWebsite";
import { ISetWebsiteAction } from "./actions/setWebsite";
import { IStartLoadingWebsiteAction } from "./actions/setWebsiteLoadingStatus";

export const WebsiteBuilderConfigActionType = {
  START_LOADING_WEBSITE: "websiteBuilderConfig.START_LOADING_WEBSITE",
  LOAD_WEBSITE: "websiteBuilderConfig.LOAD_WEBSITE",
  SET_WEBSITE: "websiteBuilderConfig.SET_WEBSITE",
} as const;

export type TWebsiteBuilderConfigAction =
  IStartLoadingWebsiteAction |
  ILoadWebsiteAction |
  ISetWebsiteAction;

const allowedConfigActionTypes = new Set<string>(Object.values(WebsiteBuilderConfigActionType));

export function isWebsiteBuilderConfigAction(action: AnyAction): action is TWebsiteBuilderConfigAction {
  return typeof action.type === "string" && allowedConfigActionTypes.has(action.type);
}